module.exports = __webpack_public_path__ + "media/index5.56936f30.webm";